<div content gdColumns="repeat(1, 1fr)" gdGap="8px">
  @for (project of projectList; track project) {
    <div class="recent-project-card card" (click)="selectProject(project)">
      <span class="category">{{ project.ParentAddress }}</span>
      <h3 class="project-title">
        {{ project.Label }}
      </h3>
      <span>{{ project.StartDate | date: "shortDate" : "" : locale }}</span>

      <div class="divider"></div>

      <div class="stats-container">
        <div class="stat-item">
          <span class="stat-value">{{ project.subProjectsCount }}</span>
          <span class="stat-label">{{
            dataService.res("Company-Sub-Project")
          }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-value">{{ project.measuresCount }}</span>
          <span class="stat-label">{{
            dataService.res("Company-Measures")
          }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-value">{{ project.tasksCount }}</span>
          <span class="stat-label">{{
            dataService.res("Company-Milestones")
          }}</span>
        </div>
      </div>
    </div>
  }
</div>
